import LinearProgress from "@/components/ui/LinearProgress";
import useGlobals from "@/utils/hooks/useGlobals.ts";
import { fadeInBottom } from "@/utils/motion/fade-in-bottom.ts";
import { cn } from "@edusogno/lib/utils";
import { motion } from "framer-motion";
import * as React from "react";
import { useLocation } from "react-router-dom";

type Props = {
  className?: string;
  children?: React.ReactNode;
  loading?: boolean;
};

const DashboardContentLayout: React.FC<Props> = React.memo(
  ({ className, children, loading }) => {
    const { backgroundClass, containerize, showSideBar } = useGlobals();
    const location = useLocation();

    return (
      <motion.div
        key={location.pathname}
        variants={fadeInBottom()}
        aria-label="container"
        className={cn(
          "flex w-full overflow-y-scroll @container/content 3xl:container 3xl:mx-auto [--content-height:calc(100%_-_84px)] lg:[--content-height:calc(100%_-_80px)] flex-col md:px-[--page-padding-h-lg] px-4 py-[--page-padding-v-lg] until-md:pt-28 h-full lg:min-h-full lg:h-full max-w-full",
          {
            "until-xl:!pt-4": !showSideBar,
            "3xl:container 3xl:mx-auto": containerize,
          },
          backgroundClass,
          className,
        )}
      >
        {loading ? <LinearProgress /> : children}
      </motion.div>
    );
  },
);
export default DashboardContentLayout;
